export default {
  data() {
    return {
      soundEffects: {
        /*
        Format: soundEffectKey: soundPath
        */
      },
      audioPlayers: {},
    }
  },
  mounted() {
    // Init all audio players from registered sounds
    const soundEffectKeys = Object.keys(this.soundEffects)

    for (var i = 0; i < soundEffectKeys.length; i++) {
      this.audioPlayers[soundEffectKeys[i]] = new Audio(this.soundEffects[soundEffectKeys[i]])
      this.audioPlayers[soundEffectKeys[i]].volume = 0.1
      this.audioPlayers[soundEffectKeys[i]].addEventListener('ended', this.audioPlayerEnded)
    }
  },
  beforeDestroy() {
    // Remove ended event from all audio players
    const soundEffectKeys = Object.keys(this.soundEffects)

    for (var i = 0; i < soundEffectKeys.length; i++) {
      this.audioPlayers[soundEffectKeys[i]].removeEventListener('ended', this.audioPlayerEnded)
    }
  },
  methods: {
    playSoundEffect(soundEffectKey) {
      // Sanity check
      if (!this.audioPlayers[soundEffectKey])
        return

      // Rewind and play
      this.audioPlayers[soundEffectKey].currentTime = 0
      this.audioPlayers[soundEffectKey].play()
    },
    audioPlayerEnded(event) {
      if (event && event.currentTarget && event.currentTarget.pause) {
        event.currentTarget.pause()
        event.currentTarget.load()
      }
    },
  }
}
